export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      {/* Background image */}
      <img
        src="https://readdy.ai/api/search-image?query=Aesthetic%20flat%20lay%20composition%20featuring%20modern%20fashion%20accessories%20sneakers%20watch%20and%20leather%20goods%20arranged%20on%20textured%20white%20linen%20with%20potted%20monstera%20leaf%20and%20ceramic%20coffee%20cup%20soft%20diffused%20morning%20sunlight%20from%20large%20unseen%20window%20creating%20gentle%20natural%20shadows%20editorial%20lifestyle%20photography%20Scandinavian%20minimalist%20aesthetic%20muted%20sage%20green%20sand%20and%20terracotta%20accent%20tones%20clean%20airy%20atmosphere%20high%20end%20boutique%20catalog%20style%20organized%20harmonious%20layout%20with%20generous%20negative%20space%20calm%20serene%20productive%20morning%20mood&width=1600&height=900&seq=hero-bg-cssbuy-v2&orientation=landscape"
        alt="CSSBuy Spreadsheet - Melhor guia de produtos em português"
        title="CSSBuy Spreadsheet 2026 - Produtos organizados"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="eager"
      />

      {/* Dark overlay for text contrast */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex items-center px-6 md:px-10">
        <div className="max-w-7xl mx-auto w-full">
          <div className="max-w-2xl">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
              Melhor CSSBuy<br />
              Spreadsheet em<br />
              Português 2026
            </h1>
            <p className="text-white/75 text-base md:text-lg mb-10 max-w-lg leading-relaxed">
              Descubra os melhores produtos, links verificados e planilhas atualizadas do CSSBuy para Portugal e Brasil. Economize tempo e compre com mais segurança.
            </p>
            <div className="flex flex-col sm:flex-row items-start gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-2 px-8 py-3.5 bg-white text-foreground-950 text-sm font-semibold rounded-full hover:bg-foreground-950 hover:text-white transition-all cursor-pointer whitespace-nowrap"
              >
                buy it now
                <i className="ri-arrow-right-up-line text-base"></i>
              </a>
              <a
                href="#categories"
                className="flex items-center gap-2 px-8 py-3.5 border border-white/40 text-white text-sm font-medium rounded-full hover:bg-white/15 transition-all cursor-pointer whitespace-nowrap"
              >
                Explorar Produtos
                <i className="ri-arrow-down-line text-base"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}